import {createSelector} from 'reselect';
import xss from '../../form/field-validation/xss';
import getAddressDefinitions from '../getAddressDefinitions';
import getAddresses from './getAddresses';

export default addressId => createSelector(
  [getAddresses, getAddressDefinitions],
  (addresses, addressDefinitions) => {
    const address = addresses[addressId];
    let isValid = true;
    let definitions = addressDefinitions;
    
    // handle PCA
    if (addressDefinitions.some(definition => definition.element === 'PostcodeAnywhere')) {
      definitions = [
        ...addressDefinitions,
        ...addressDefinitions.find(definition => definition.element === 'PostcodeAnywhere').fields,
      ];
    }
    
    if (address) {
      Object.keys(address).forEach((addressField) => {
        if (definitions.some(definition => definition.name === addressField) && isValid) {
          let validations = definitions.find(definition => definition.name === addressField).validate;
          
          if (typeof validations === 'function') {
            validations = [validations];
          }
          
          validations.push(xss);
          
          const addressErrors = validations.reduce((errors, validation) => {
            const error = validation(address[addressField]);
            if (error) {
              errors.field.push(addressField);
              errors.errorCode.push(error);
            }
            return errors;
          }, {field: [], errorCode: []});
          
          if (addressErrors.field?.length > 0) {
            isValid = false;
          }
        }
      });
    }
    
    return ({name: 'isValidAddress', value: isValid});
  },
);
